<div class="checkout-container">
  <div class="header">
    <h1 class="title">{{'CHECKOUT_TEMPLATE' | translate}}</h1>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>

  <div *ngIf="!loading" class="form-card mb-5" [formGroup]="form">
    <div class="switch-container mb-4">
      <mat-slide-toggle class="switch" formControlName="useDefaults">
        {{'CHECKOUT_DEFAULT_TEMPLATE' | translate : { fallback: 'Usar valores por defecto' } }}
      </mat-slide-toggle>
      <small class="text-muted">
        {{ 'CHECKOUT_DEFAULTS_SWITCH_HELP' | translate }}
      </small>
    </div>

    <div class="editor-toolbar product-translation-toolbar">
      <div class="language-toggle" role="tablist">
        <button
          type="button"
          class="language-toggle__button"
          [class.is-active]="selectedLanguage === 'es'"
          (click)="selectLanguage('es')">
          {{ 'SPANISH' | translate }}
        </button>
        <button
          type="button"
          class="language-toggle__button"
          [class.is-active]="selectedLanguage === 'en'"
          (click)="selectLanguage('en')">
          {{ 'ENGLISH' | translate }}
        </button>
      </div>
    </div>

    <div [hidden]="selectedLanguage !== 'es'">
      <div class="row mb-3">
        <div class="col-6 d-flex flex-column">
          <label>{{'SHOPPING_CART' | translate}}</label>

          <ng-container *ngIf="!form.get('useDefaults')?.value; else defaultCartTitle">
            <input
              formControlName="cartTitle"
              [ngClass]="{'is-invalid': showErrors && f.cartTitle.invalid}" />
            <small class="text-muted">{{ 'CHECKOUT_CART_TITLE_HELP' | translate }}</small>
            <div class="invalid-feedback" *ngIf="showErrors && f.cartTitle.errors?.['required']">
              {{'REQUIRED_FIELD' | translate}}
            </div>
          </ng-container>
          <ng-template #defaultCartTitle>
            <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.cartTitle }}</p>
          </ng-template>
        </div>

        <div class="col-6 d-flex flex-column">
          <label>{{'ITEM_LIST' | translate}}</label>

          <ng-container *ngIf="!form.get('useDefaults')?.value; else defaultItemList">
            <input
              formControlName="itemListTitle"
              [ngClass]="{'is-invalid': showErrors && f.itemListTitle.invalid}" />
            <small class="text-muted">{{ 'CHECKOUT_ITEM_LIST_HELP' | translate }}</small>
            <div class="invalid-feedback" *ngIf="showErrors && f.itemListTitle.errors?.['required']">
              {{'REQUIRED_FIELD' | translate}}
            </div>
          </ng-container>
          <ng-template #defaultItemList>
            <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.itemListTitle }}</p>
          </ng-template>
        </div>
      </div>

      <hr />

      <div class="row mb-3">
        <div class="col-6 d-flex flex-column">
          <label>{{'CHECKOUT' | translate}}</label>

          <ng-container *ngIf="!form.get('useDefaults')?.value; else defaultCheckoutTitle">
            <input
              formControlName="checkoutSideTitle"
              [ngClass]="{'is-invalid': showErrors && f.checkoutSideTitle.invalid}" />
            <small class="text-muted">{{ 'CHECKOUT_SIDE_TITLE_HELP' | translate }}</small>
            <div class="invalid-feedback" *ngIf="showErrors && f.checkoutSideTitle.errors?.['required']">
              {{'REQUIRED_FIELD' | translate}}
            </div>
          </ng-container>
          <ng-template #defaultCheckoutTitle>
            <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.checkoutSideTitle }}</p>
          </ng-template>
        </div>

        <div class="col-6">
          <label class="d-block">{{'ENABLE_SHIPPING' | translate}}</label>

          <div class="switch-container">
            <ng-container *ngIf="!form.get('useDefaults')?.value; else defaultShipping">
              <mat-slide-toggle class="switch" formControlName="shippingEnabled">
                {{'SHIPPING' | translate}}
              </mat-slide-toggle>
              <small class="text-muted">{{ 'CHECKOUT_SHIPPING_HELP' | translate }}</small>
            </ng-container>
            <ng-template #defaultShipping>
              <p class="form-control-plaintext">
                {{ CHECKOUT_DEFAULTS.shippingEnabled ? ('ENABLED' | translate) : ('DISABLED' | translate) }}
              </p>
            </ng-template>
          </div>
        </div>
      </div>

      <hr />

      <div class="switch-container mb-4">
        <ng-container *ngIf="!form.get('useDefaults')?.value; else defaultFooter">
          <mat-slide-toggle class="switch" formControlName="footerEnabled">
            Footer
          </mat-slide-toggle>
          <small class="text-muted">{{ 'CHECKOUT_FOOTER_HELP' | translate }}</small>
        </ng-container>
        <ng-template #defaultFooter>
          <p class="form-control-plaintext">
            Footer {{ CHECKOUT_DEFAULTS.footerEnabled ? ('ENABLED' | translate) : ('DISABLED' | translate) }}
          </p>
        </ng-template>
      </div>

      <div
        class="row"
        formGroupName="footerCols"
        *ngIf="!form.get('useDefaults')?.value && form.get('footerEnabled')?.value">

        <div class="col-3" formGroupName="col1">
          <label>Col 1 – {{'TITLE' | translate}}</label>
          <div class="d-flex flex-column">
            <input formControlName="title" />
            <small class="text-muted">{{ 'CHECKOUT_FOOTER_COL1_HELP' | translate }}</small>
            <label class="mt-2">{{'SUBTITLE' | translate}}</label>
            <textarea formControlName="subtitle" rows="3"></textarea>
          </div>
        </div>

        <div class="col-3" formGroupName="col2">
          <label>Col 2 – {{'TITLE' | translate}}</label>
          <div class="d-flex flex-column">
            <input formControlName="title" />
            <small class="text-muted">{{ 'CHECKOUT_FOOTER_COL2_HELP' | translate }}</small>
            <label class="mt-2">{{'SUBTITLE' | translate}}</label>
            <textarea formControlName="subtitle" rows="3"></textarea>
          </div>
        </div>

        <div class="col-3" formGroupName="col3">
          <label>Col 3 – {{'TITLE' | translate}}</label>
          <div class="d-flex flex-column">
            <input formControlName="title" />
            <small class="text-muted">{{ 'CHECKOUT_FOOTER_COL3_HELP' | translate }}</small>
            <label class="mt-2">{{'SUBTITLE' | translate}}</label>
            <textarea formControlName="subtitle" rows="3"></textarea>
          </div>
        </div>

        <div class="col-3" formGroupName="col4">
          <label>Col 4 – {{'TITLE' | translate}}</label>
          <div class="d-flex flex-column">
            <input formControlName="title" />
            <small class="text-muted">{{ 'CHECKOUT_FOOTER_COL4_HELP' | translate }}</small>
            <label class="mt-2">{{'SUBTITLE' | translate}}</label>
            <textarea formControlName="subtitle" rows="3"></textarea>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="form.get('useDefaults')?.value && CHECKOUT_DEFAULTS.footerEnabled">
        <div class="col-3">
          <label>Col 1 – {{'TITLE' | translate}}</label>
          <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.footerCols.col1.title }}</p>
          <small class="text-muted">{{ CHECKOUT_DEFAULTS.footerCols.col1.subtitle }}</small>
        </div>
        <div class="col-3">
          <label>Col 2 – {{'TITLE' | translate}}</label>
          <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.footerCols.col2.title }}</p>
          <small class="text-muted">{{ CHECKOUT_DEFAULTS.footerCols.col2.subtitle }}</small>
        </div>
        <div class="col-3">
          <label>Col 3 – {{'TITLE' | translate}}</label>
          <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.footerCols.col3.title }}</p>
          <small class="text-muted">{{ CHECKOUT_DEFAULTS.footerCols.col3.subtitle }}</small>
        </div>
        <div class="col-3">
          <label>Col 4 – {{'TITLE' | translate}}</label>
          <p class="form-control-plaintext">{{ CHECKOUT_DEFAULTS.footerCols.col4.title }}</p>
          <small class="text-muted">{{ CHECKOUT_DEFAULTS.footerCols.col4.subtitle }}</small>
        </div>
      </div>
    </div>

    <div class="translation-layout" [hidden]="selectedLanguage !== 'en'">
      <div class="row mb-3">
        <div class="col-6 d-flex flex-column translation-inline-field">
          <div class="translation-field-header">
            <label>{{ 'SHOPPING_CART' | translate }} (EN)</label>
            <label class="translation-switch" *ngIf="!form.get('useDefaults')?.value" title="Marcar como traducción manual">
              <input
                type="checkbox"
                [checked]="isEnglishFieldManual('cartTitle')"
                (change)="onManualFieldToggle('cartTitle', $event)"
              />
              <span class="translation-switch__slider"></span>
            </label>
          </div>
          <ng-container *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldReadonly('cartTitle'); else englishCartTitlePreview">
            <input
              type="text"
              class="form-control"
              [ngModel]="getEnglishFieldValue('cartTitle')"
              (ngModelChange)="updateEnglishField('cartTitle', $event)"
              [ngModelOptions]="{ standalone: true }"
            />
          </ng-container>
          <ng-template #englishCartTitlePreview>
            <div class="translation-preview-html">{{ getEnglishFieldValue('cartTitle') }}</div>
          </ng-template>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && isEnglishFieldManual('cartTitle')">{{ 'ENGLISH_MANUAL_HELPER' | translate }}</div>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual('cartTitle') && !hasEnglishFieldPreview('cartTitle')">{{ 'ENGLISH_NO_PERSISTED_FALLBACK' | translate }}</div>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual('cartTitle') && hasEnglishFieldPreview('cartTitle')">{{ 'ENGLISH_READONLY_HELPER' | translate }}</div>
        </div>

        <div class="col-6 d-flex flex-column translation-inline-field">
          <div class="translation-field-header">
            <label>{{ 'ITEM_LIST' | translate }} (EN)</label>
            <label class="translation-switch" *ngIf="!form.get('useDefaults')?.value" title="Marcar como traducción manual">
              <input
                type="checkbox"
                [checked]="isEnglishFieldManual('itemListTitle')"
                (change)="onManualFieldToggle('itemListTitle', $event)"
              />
              <span class="translation-switch__slider"></span>
            </label>
          </div>
          <ng-container *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldReadonly('itemListTitle'); else englishItemListPreview">
            <input
              type="text"
              class="form-control"
              [ngModel]="getEnglishFieldValue('itemListTitle')"
              (ngModelChange)="updateEnglishField('itemListTitle', $event)"
              [ngModelOptions]="{ standalone: true }"
            />
          </ng-container>
          <ng-template #englishItemListPreview>
            <div class="translation-preview-html">{{ getEnglishFieldValue('itemListTitle') }}</div>
          </ng-template>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && isEnglishFieldManual('itemListTitle')">{{ 'ENGLISH_MANUAL_HELPER' | translate }}</div>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual('itemListTitle') && !hasEnglishFieldPreview('itemListTitle')">{{ 'ENGLISH_NO_PERSISTED_FALLBACK' | translate }}</div>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual('itemListTitle') && hasEnglishFieldPreview('itemListTitle')">{{ 'ENGLISH_READONLY_HELPER' | translate }}</div>
        </div>
      </div>

      <hr />

      <div class="row mb-3">
        <div class="col-6 d-flex flex-column translation-inline-field">
          <div class="translation-field-header">
            <label>{{ 'CHECKOUT' | translate }} (EN)</label>
            <label class="translation-switch" *ngIf="!form.get('useDefaults')?.value" title="Marcar como traducción manual">
              <input
                type="checkbox"
                [checked]="isEnglishFieldManual('checkoutSideTitle')"
                (change)="onManualFieldToggle('checkoutSideTitle', $event)"
              />
              <span class="translation-switch__slider"></span>
            </label>
          </div>
          <ng-container *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldReadonly('checkoutSideTitle'); else englishCheckoutSideTitlePreview">
            <input
              type="text"
              class="form-control"
              [ngModel]="getEnglishFieldValue('checkoutSideTitle')"
              (ngModelChange)="updateEnglishField('checkoutSideTitle', $event)"
              [ngModelOptions]="{ standalone: true }"
            />
          </ng-container>
          <ng-template #englishCheckoutSideTitlePreview>
            <div class="translation-preview-html">{{ getEnglishFieldValue('checkoutSideTitle') }}</div>
          </ng-template>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && isEnglishFieldManual('checkoutSideTitle')">{{ 'ENGLISH_MANUAL_HELPER' | translate }}</div>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual('checkoutSideTitle') && !hasEnglishFieldPreview('checkoutSideTitle')">{{ 'ENGLISH_NO_PERSISTED_FALLBACK' | translate }}</div>
          <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual('checkoutSideTitle') && hasEnglishFieldPreview('checkoutSideTitle')">{{ 'ENGLISH_READONLY_HELPER' | translate }}</div>
        </div>

        <div class="col-6 translation-placeholder">
          <div class="switch-container">
            <p class="form-control-plaintext" *ngIf="form.get('useDefaults')?.value">
              {{ CHECKOUT_DEFAULTS.shippingEnabled ? ('ENABLED' | translate) : ('DISABLED' | translate) }}
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div class="switch-container mb-4 translation-footer-header">
        <p class="form-control-plaintext" *ngIf="form.get('useDefaults')?.value">
          Footer {{ CHECKOUT_DEFAULTS.footerEnabled ? ('ENABLED' | translate) : ('DISABLED' | translate) }}
        </p>
      </div>

      <div
        class="row"
        *ngIf="(!form.get('useDefaults')?.value && form.get('footerEnabled')?.value) || (form.get('useDefaults')?.value && CHECKOUT_DEFAULTS.footerEnabled)">
        <div class="col-3 translation-footer-column" *ngFor="let column of footerColumnKeys">
          <div class="translation-inline-field">
            <div class="translation-field-header">
              <label>{{ getFooterColumnLabel(column) }} - {{ 'TITLE' | translate }} (EN)</label>
              <label class="translation-switch" *ngIf="!form.get('useDefaults')?.value" title="Marcar como traducción manual">
                <input
                  type="checkbox"
                  [checked]="isEnglishFieldManual(getFooterFieldPath(column, 'title'))"
                  (change)="onManualFieldToggle(getFooterFieldPath(column, 'title'), $event)"
                />
                <span class="translation-switch__slider"></span>
              </label>
            </div>
            <ng-container *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldReadonly(getFooterFieldPath(column, 'title')); else englishFooterTitlePreview">
              <input
                type="text"
                class="form-control"
                [ngModel]="getEnglishFieldValue(getFooterFieldPath(column, 'title'))"
                (ngModelChange)="updateEnglishField(getFooterFieldPath(column, 'title'), $event)"
                [ngModelOptions]="{ standalone: true }"
              />
            </ng-container>
            <ng-template #englishFooterTitlePreview>
              <div class="translation-preview-html">{{ getEnglishFieldValue(getFooterFieldPath(column, 'title')) }}</div>
            </ng-template>
            <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && isEnglishFieldManual(getFooterFieldPath(column, 'title'))">{{ 'ENGLISH_MANUAL_HELPER' | translate }}</div>
            <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual(getFooterFieldPath(column, 'title')) && !hasEnglishFieldPreview(getFooterFieldPath(column, 'title'))">{{ 'ENGLISH_NO_PERSISTED_FALLBACK' | translate }}</div>
            <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual(getFooterFieldPath(column, 'title')) && hasEnglishFieldPreview(getFooterFieldPath(column, 'title'))">{{ 'ENGLISH_READONLY_HELPER' | translate }}</div>
          </div>

          <div class="translation-inline-field translation-inline-field--spaced">
            <div class="translation-field-header">
              <label>{{ getFooterColumnLabel(column) }} - {{ 'SUBTITLE' | translate }} (EN)</label>
              <label class="translation-switch" *ngIf="!form.get('useDefaults')?.value" title="Marcar como traducción manual">
                <input
                  type="checkbox"
                  [checked]="isEnglishFieldManual(getFooterFieldPath(column, 'subtitle'))"
                  (change)="onManualFieldToggle(getFooterFieldPath(column, 'subtitle'), $event)"
                />
                <span class="translation-switch__slider"></span>
              </label>
            </div>
            <ng-container *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldReadonly(getFooterFieldPath(column, 'subtitle')); else englishFooterSubtitlePreview">
              <textarea
                class="form-control"
                rows="3"
                [ngModel]="getEnglishFieldValue(getFooterFieldPath(column, 'subtitle'))"
                (ngModelChange)="updateEnglishField(getFooterFieldPath(column, 'subtitle'), $event)"
                [ngModelOptions]="{ standalone: true }">
              </textarea>
            </ng-container>
            <ng-template #englishFooterSubtitlePreview>
              <div class="translation-preview-html translation-preview-html--textarea">{{ getEnglishFieldValue(getFooterFieldPath(column, 'subtitle')) }}</div>
            </ng-template>
            <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && isEnglishFieldManual(getFooterFieldPath(column, 'subtitle'))">{{ 'ENGLISH_MANUAL_HELPER' | translate }}</div>
            <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual(getFooterFieldPath(column, 'subtitle')) && !hasEnglishFieldPreview(getFooterFieldPath(column, 'subtitle'))">{{ 'NO_CONTENT_AVAILABLE_YET' | translate }}</div>
            <div class="helper-text" *ngIf="!form.get('useDefaults')?.value && !isEnglishFieldManual(getFooterFieldPath(column, 'subtitle')) && hasEnglishFieldPreview(getFooterFieldPath(column, 'subtitle'))">{{ 'ENGLISH_READONLY_HELPER' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions mt-5 d-flex justify-content-center">
      <button class="primary-btn" (click)="saveCheckoutTemplate()">
        {{'SAVE' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal checkout-confirm-modal" id="checkoutSuccessModal" tabindex="-1">
  <div class="modal-dialog checkout-modal-dialog" role="document">
    <div class="modal-content checkout-modal-content">
      <div class="modal-body checkout-modal-body">
        <div class="success-check-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none"
               stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="14 26 22 34 38 18" />
          </svg>
        </div>
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{ "CHECKOUT_TEMPLATE_SUCCESS" | translate }}</p>
      </div>
    </div>
  </div>
</div>

<div class="modal checkout-confirm-modal" id="checkoutRequiredModal" tabindex="-1">
  <div class="modal-dialog checkout-modal-dialog" role="document">
    <div class="modal-content checkout-modal-content">
      <div class="modal-body checkout-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{ "ALL_FIELDS_REQUIRED" | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal checkout-confirm-modal" id="checkoutErrorModal" tabindex="-1">
  <div class="modal-dialog checkout-modal-dialog" role="document">
    <div class="modal-content checkout-modal-content">
      <div class="modal-body checkout-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{ "ERROR_SAVING_CHANGES" | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
